import { useRef } from 'react';
import classnames from 'classnames';

import styles from './FileInput.module.scss';

import { CommonTestAttributes } from 'chaika-test-attributes';

export enum AcceptTypes {
    Docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
}

export const FileTypesDictionary = {
    [AcceptTypes.Docx]: 'docx',
};

interface Props {
    children: React.ReactNode | React.ReactNode[];
    isDisabled?: boolean;
    withoutPaddings?: boolean;
    multipleFileLoad?: boolean;
    acceptFileTypes?: AcceptTypes[];
    onFileAdd?(files: File[]): void | Promise<void>;
}

export function FileInput({
    children,
    isDisabled,
    withoutPaddings,
    multipleFileLoad = true,
    acceptFileTypes,
    onFileAdd,
}: Props) {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleClick = (): void => {
        if (inputRef.current && !isDisabled) {
            inputRef.current.click();
        }
    };

    const handleChange = (): void => {
        const input = inputRef.current;

        if (input && !isDisabled) {
            const files = input.files;
            if (onFileAdd && files) {
                onFileAdd(Array.from(files));
            }
            input.value = '';
        }
    };

    return (
        <div
            className={classnames([styles.root, withoutPaddings && styles.root_withoutPaddings])}
            data-test={CommonTestAttributes.FileDragAndDropLoad}
            data-testid={CommonTestAttributes.FileDragAndDropLoad}
            onClick={handleClick}
        >
            <div className={classnames([styles.icon, isDisabled && styles.icon_disabled])}>{children}</div>

            <input
                className={styles.input}
                type="file"
                accept={acceptFileTypes?.join() ?? undefined}
                multiple={multipleFileLoad}
                ref={inputRef}
                onChange={handleChange}
            />
        </div>
    );
}
